import type {Component} from 'vue'
import {PermissionEntityType} from '@toolify/server/src/models/mongoose/PermissionModel/enum/PermissionEntityType'
import UserPermissionEntityTypeThumbnailStrategy from '../strategies/UserPermissionEntityTypeThumbnailStrategy.vue'
import GroupPermissionEntityTypeThumbnailStrategy from '../strategies/GroupPermissionEntityTypeThumbnailStrategy.vue'
import AppPermissionEntityTypeThumbnailStrategy from '../strategies/AppPermissionEntityTypeThumbnailStrategy.vue'
import AgentPermissionEntityTypeThumbnailStrategy from '../strategies/AgentPermissionEntityTypeThumbnailStrategy.vue'

export const PermissionEntityTypeThumbnailStrategyMap = new Map<PermissionEntityType, Component>([
  [PermissionEntityType.User, UserPermissionEntityTypeThumbnailStrategy],
  [PermissionEntityType.Group, GroupPermissionEntityTypeThumbnailStrategy],
  [PermissionEntityType.App, AppPermissionEntityTypeThumbnailStrategy],
  [PermissionEntityType.Agent, AgentPermissionEntityTypeThumbnailStrategy],
])
